import { useEffect, useState } from "react";

export const useMount = (): boolean => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted;
};
